$(document).ready(function() {  

  $(".shifter-handle").click(function () {
    
    if ($('body').is('.shifter-open')) {
      
      	$('.zopim').removeClass('away-chat');
      
    }
    else {
    	$('.zopim').addClass('away-chat');
    }
  });
  
  $(".shifter-page").click(function () {
    
    if ($('.zopim').is('.away-chat')) {
      
      $('.zopim').removeClass('away-chat');
    }
  });
  
}); 